import { hasRole } from './roles';
import { canOnInstance } from './access';

/**
 * May this visitor open a workshop view of `instanceId`? The client's copy of
 * checkInstanceAccess in apps/backend/src/middleware/instanceAccess.js:
 * `participate` on the instance, which an admin role, a grant, or a PIN
 * session for that instance gives. The server still checks every request;
 * this keeps the gate from drawing a module the visitor cannot use.
 *
 * Returns 'ok', 'signin' (no session at all) or 'instance' (a session that
 * does not reach this instance). Without an instance in the URL the view
 * uses the session's own, so any session will do.
 *
 * @param {{ me?: object|null, hasPinSession: boolean, pinInstanceId?: string|null, instanceId?: string|null }} args
 * @returns {'ok'|'signin'|'instance'}
 */
export function workshopAccess({ me, hasPinSession, pinInstanceId, instanceId }) {
  const signedIn = Boolean(me?.email);
  if (!hasPinSession && !signedIn) return 'signin';
  if (!instanceId) return 'ok';
  if (signedIn && (hasRole(me, 'admin') || canOnInstance(me, instanceId, 'participate'))) return 'ok';
  if (hasPinSession && pinInstanceId === instanceId) return 'ok';
  return 'instance';
}
